import React, { useEffect } from 'react';
import ConfidenceChip from './ConfidenceChip';
import './AIPickCard.css';

const AIPickCard = ({ pick, onAddToBetSlip, analytics }) => {
  const formatOdds = (odds) => odds > 0 ? `+${odds}` : `${odds}`;
  
  const formatGameTime = (gameTime, gameDate) => {
    // Combine date and time if both provided
    let dateStr = gameTime;
    if (gameDate && gameTime && !gameTime.includes('T') && !gameTime.includes('-')) {
      dateStr = `${gameDate}T${gameTime}`;
    }
    
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      return gameTime || 'TBD'; // Fallback to raw value
    }
    
    const today = new Date();
    const isToday = date.toDateString() === today.toDateString();
    
    const timeString = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
    
    if (isToday) {
      return `Today ${timeString}`;
    } else {
      return `${date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric' 
      })} ${timeString}`;
    }
  };

  // Track pick view
  useEffect(() => {
    if (analytics && analytics.trackPickViewed) {
      analytics.trackPickViewed(pick);
    }
  }, [pick.id, analytics]);

  const handleAddToBetSlip = () => {
    if (analytics && analytics.trackPickAddedToSlip) {
      analytics.trackPickAddedToSlip(pick.id);
    }
    if (onAddToBetSlip) {
      onAddToBetSlip(pick);
    }
  };

  return (
    <div className="ai-pick-card">
      <div className="pick-header">
        <ConfidenceChip confidence={pick.confidence} />
        <span className="odds">{formatOdds(pick.odds)}</span>
      </div>
      
      <div className="pick-content">
        <div className="matchup">{pick.matchup}</div>
        <div className="selection">{pick.selection}</div>
        <div className="game-time">🕐 {formatGameTime(pick.game_time || pick.gameTime, pick.date)}</div>
      </div>

      <div className="pick-reasoning">
        <div className="reasoning-label">AI Analysis:</div>
        <div className="reasoning-text">{pick.reasoning}</div>
      </div>

      <div className="pick-actions">
        <button 
          className="add-bet-btn"
          onClick={handleAddToBetSlip}
        >
          ⚡ Add to Bet Slip
        </button>
      </div>
    </div>
  );
};

export default AIPickCard;
